module.exports = __webpack_public_path__ + "img/1.e4b9e0e5.png";